<template>
  <div id="app">
    <!--<web-nav></web-nav>-->
    <router-view class="min-height" />
    <footer>
      <!--<span>© 2021 Math Global Co., Ltd. All rights reserved.</span>-->
      <a
        href="https://twitter.com/Mathwallet"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/static/img/foot/twitter.png" width="32" />
      </a>
      <a
        href="https://t.me/mathwalletnews"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/static/img/foot/telegram.png" width="32" />
      </a>
      <!-- <a href="javascript:;">
        <img src="@/static/img/foot/wechat.png" width="32" />
        <img src="@/static/img/foot/wechatgroup.jpg" class="qrcode" />
      </a> -->
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  created() {
    let chain = window.location.hash
      ? window.location.hash.toLowerCase().match(/[\w\%]+/g)
        ? window.location.hash.toLowerCase().match(/[\w\%]+/)[0]
        : "eth"
      : "eth";
    this.init(chain);
  },
  computed: {
    ...mapGetters({
      chainList: "chainList",
    }),
  },
  methods: {
    ...mapActions([
      "setCurrentChain",
      "setCoins",
      "setCoinsInfo",
      "setNftAccount",
      "setOwner",
    ]),
    init(chain) {
      if (!this.chainList[chain]) {
        chain = "eth";
        this.$router.push(this.root);
      }
      // 全称
      this.setCurrentChain(chain);

      this.getCoinList();
    },
    async getCoinList() {
      let info = await this.getCoinPub("https://market.maiziqianbao.net/");
      if (info.length > 0) {
        this.coinChange(this.unit);
        let coinsList = [];
        info.map((coinInfo) => {
          coinsList.push(coinInfo.alias);
        });
        this.setCoins(coinsList);
        this.setCoinsInfo(info);
      }
    },
    async getNFTOwner() {
      try {
        if (!this.nftAccount) {
          this.setOwner("");
          return false;
        }
        let contract = await this.user?.getContractABI(this.nftAccount);
        let owner = await contract?.owner();
        this.setOwner(owner);
      } catch (err) {
        this.setOwner("");
      }
    },
  },
  watch: {
    async $route(to, from) {
      let nftAccount = to?.query?.addr;
      if (nftAccount) {
        let isContract = await this.user?.getIsContract(nftAccount);
        if (!isContract) {
          nftAccount = "";
        }
      }
      this.setNftAccount(nftAccount);
      let fromName = from?.matched?.length ? from?.matched[0]?.name : "";
      if (
        to.matched[0].name != fromName ||
        to?.query?.addr != from?.query?.addr
      ) {
        this.getNFTOwner();
      }
    },
  },
};
</script>
